import palette from './palette';
import {generateTokensFromObject} from '../__utils';

import type {CoreColors} from './colors.types';

const {colors} = palette;

const d1Colors = {
  black: colors.black,
  blackA5: 'rgba(0, 0, 0, 0.05)',
  blackA10: 'rgba(0, 0, 0, 0.1)',
  blackA25: 'rgba(0, 0, 0, 0.25)',
  blackA50: 'rgba(0, 0, 0, 0.50)',
  blackA75: 'rgba(0, 0, 0, 0.75)',
  white: colors.white,
  whiteA5: 'rgba(255, 255, 255, 0.05)',
  whiteA10: 'rgba(255, 255, 255, 0.1)',
  whiteA25: 'rgba(255, 255, 255, 0.25)',
  whiteA50: 'rgba(255, 255, 255, 0.50)',
  whiteA75: 'rgba(255, 255, 255, 0.75)',
  gray: {
    '25': colors.gray25, // only used for  light theme
    '50': colors.gray50,
    '100': colors.gray100,
    '200': colors.gray200,
    '300': colors.gray300,
    '350': colors.gray350,
    '400': colors.gray400,
    '500': colors.gray500,
    '600': colors.gray600,
    '700': colors.gray700,
    '800': colors.gray800,
    '900': colors.gray900,
  },
  blue: {
    A10: 'rgba(0, 115, 230, 0.1)',
    A20: 'rgba(0, 115, 230, 0.2)',
    A30: 'rgba(0, 115, 230, 0.3)',
    '100': '#8AC2FF',
    '200': '#2496FF',
    '300': '#0084FF',
    '350': '#1280EE',
    '400': '#0073E6',
    '500': '#0066FF',
    '600': '#005CE5',
  },
  green: {
    A10: 'rgba(0, 133, 71, 0.1)',
    A20: 'rgba(0, 133, 71, 0.2)',
    A30: 'rgba(0, 133, 71, 0.3)',
    '100': '#63D489',
    '200': '#2FC862',
    '300': '#00a457',
    '350': '#00944F',
    '400': '#008547',
    '500': '#00713C',
  },
  orange: {
    A10: 'rgba(248, 89, 0, 0.1)',
    A20: 'rgba(248, 89, 0, 0.2)',
    A30: 'rgba(248, 89, 0, 0.3)',
    '100': '#FFAB66',
    '200': '#F67E28',
    '300': '#F85900',
    '350': '#DD7124',
    '400': '#C75300',
  },
  pink: {
    A10: 'rgba(190, 74, 165, 0.1)',
    A20: 'rgba(190, 74, 165, 0.2)',
    A30: 'rgba(190, 74, 165, 0.3)',
    '100': '#F7A9F9',
    '200': '#F775D3',
    '300': '#E148C0',
    '350': '#D34EB7',
    '400': '#BE4AA5',
    '500': '#D914AE',
    '600': '#C3129D',
  },
  purple: {
    A10: 'rgba(127, 90, 233, 0.1)',
    A20: 'rgba(127, 90, 233, 0.2)',
    A30: 'rgba(127, 90, 233, 0.3)',
    '100': '#B89EFF',
    '200': '#A484FF',
    '300': '#8A61FF',
    '400': '#7F5AE9',
    '500': '#7140FF',
    '600': '#663AE5',
  },
  red: {
    A10: 'rgba(207, 49, 59, 0.1)',
    A20: 'rgba(207, 49, 59, 0.2)',
    A30: 'rgba(207, 49, 59, 0.3)',
    '100': '#FF8A8A',
    '200': '#FF424D',
    '300': '#ED273E',
    '350': '#DB434C',
    '400': '#CF313B',
    '500': '#D50000',
    '600': '#B50000',
  },
  yellow: {
    A10: 'rgba(255, 199, 0, 0.1)',
    A20: 'rgba(255, 199, 0, 0.2)',
    A30: 'rgba(255, 199, 0, 0.3)',
    A70: 'rgba(255, 199, 0, 0.7)',
    '300': '#FFC700',
    '400': '#EAA700',
    '450': '#AD7D00',
    '500': '#996E00',
  },
  webflowBlue: {
    A10: 'rgba(67, 83, 255, 0.1)',
    A20: 'rgba(67, 83, 255, 0.2)',
    A30: 'rgba(67, 83, 255, 0.3)',
    '100': '#738cff',
    '200': '#4d6bff',
    '300': '#4353ff',
    '400': '#3545ee',
    '500': '#323ed1',
  },
} as const;

export const coreColors: CoreColors = {
  ...d1Colors,
  d2: colors.d2,
};

const {tokens: d1Tokens, setTokens: d1SetTokens} = generateTokensFromObject(
  d1Colors,
  {
    prefix: 'd1',
    applyNamespace: true,
  }
);

const {tokens: d2Tokens, setTokens: d2SetTokens} = generateTokensFromObject(
  colors.d2,
  {
    applyNamespace: true,
  }
);

/* Adding a FixMeAny until we can get good TS support for these tokens objects */
export const coreColorTokens: any = {
  ...d1Tokens,
  d2: d2Tokens,
};

/* Used to set the initial color variable values */
export const coreColorVars = {
  ...d1SetTokens,
  ...d2SetTokens,
} as const;
